import { colors } from "../../../../utils/theme";
import React, { useState } from "react";
import styled from "styled-components";
import { TextView } from "../../..";
import { DIVIDER_SVG_STYLES_V3_ENABLED } from "../../../../constants/featureFlags";
import SvgDividerPicker from "./SvgDividerPicker";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 20px;
`;

const Box = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
  cursor: pointer;
  background-color: ${({ selected }) =>
    selected ? colors.lightGrey : colors.background};
  width: 55px;
  height: 50px;
  border-radius: 5px;
  margin-right: 16px;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
`;

const Line = styled.div`
  width: 100%;
  height: 2px;
  border-bottom: ${(props) => {
    switch (props.styleType) {
      case "solid":
        return "2px solid black";
      case "dashed":
        return "2px dashed black";
      case "dotted":
        return "2px dotted black";
      case "double":
        return "4px double black";

      default:
        return "2px solid black";
    }
  }};
`;

const DividerStyles = ({
  selectedStyle,
  setSelectedStyle,
  disabled,
  svgStyle,
  setSvgStyle,
  previewColor,
}) => {
  // DIVIDER_SVG_STYLES_V3 (DL-042): flag ON swaps the 4-box CSS row for the
  // family-grouped SVG style grid. OFF (default) falls through to the exact
  // legacy render below — byte-identical to today.
  if (DIVIDER_SVG_STYLES_V3_ENABLED) {
    return (
      <SvgDividerPicker
        selectedStyle={svgStyle}
        onSelect={setSvgStyle}
        previewColor={previewColor}
      />
    );
  }

  const styles = ["solid", "dashed", "dotted", "double"];

  return (
    <div>
      <TextView variant="subtitle">Style</TextView>
      <Container>
        {styles.map((style, index) => (
          <Box
            key={index}
            selected={selectedStyle === style}
            disabled={disabled && index >= 1}
            onClick={() => {
              if (disabled) {
                index == 1 && setSelectedStyle(style);
              } else setSelectedStyle(style);
            }}
          >
            <Line styleType={style} />
          </Box>
        ))}
      </Container>
    </div>
  );
};

export default DividerStyles;
